import React, { createContext, useContext } from 'react';
import { TemplateType, TemplateConfig } from '../../../models/Template';
import templateConfigs from '../config/template-types.json';

export interface TemplateContextType {
    templateType: TemplateType;
    config: TemplateConfig;
}

export const TemplateContext = createContext<TemplateContextType | undefined>(undefined);

export const TemplateProvider: React.FC<{
    children: React.ReactNode;
    templateType: TemplateType;
}> = ({ children, templateType }) => {
    const config = templateConfigs[templateType];
    
    return (
        <TemplateContext.Provider value={{ templateType, config }}>
            {children}
        </TemplateContext.Provider>
    );
};

export const useTemplate = () => {
    const context = useContext(TemplateContext);
    if (!context) {
        throw new Error('useTemplate must be used within a TemplateProvider');
    }
    return context;
};
